import clsx from 'clsx';
import React from 'react';
import { ArticleHeaderProps } from '@/components/article-header/types';
import Card from '@/components/card/Card';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export const ArticleHeader: React.FC<ArticleHeaderProps> = ({
  title,
  theme,
  cards,
  className,
  sectionId,
  // Discard: no image to preload, and it must not leak onto the DOM div.
  prerender: _prerender,
  ...rest
}) => {
  const renamedProps = renameDomProps(rest);
  return (
    <div
      id={sectionId}
      className={clsx(
        'smzh-page-header grid grid-cols-4 gap-6 px-4 py-24 sm:px-0 md:grid-cols-12 md:gap-14',
        theme == 'light' ? 'bg-light-grey' : 'bg-brand-700',
        className,
      )}
      data-component-id="C025"
      {...renamedProps}
    >
      <div className="col-span-full flex flex-col gap-14 md:col-start-3 md:col-end-11">
        <h1
          className={clsx(
            'max-w-full text-4xl font-bold md:max-w-xl md:text-5xl',
            theme == 'light' ? 'text-brand-700' : 'text-white',
          )}
        >
          {title}
        </h1>
        {cards && (
          <div className="flex w-full flex-col gap-6 md:flex-row md:gap-14">
            {cards.map((card, index) => (
              <Card
                {...card}
                variant="content"
                key={index}
                className="w-full md:w-1/2"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
